module.exports = __webpack_public_path__ + "static/img/3-CN.b7db4c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/3-CN.png
// module id = sdBn
// module chunks = 1